<div class="title" [ngStyle]="{ 'font-size.px': titleSize }">
  {{ title }}
</div>
